module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-monitor"
  }, [_c('div', {
    staticClass: "lead-update-monitor--section"
  }, [_c('div', {
    staticClass: "lead-update-monitor--advancement"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('progress-bar', {
    attrs: {
      "percentage": _vm.progress,
      "isMini": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.progress.toFixed()) + "%")])], 1), _vm._v(" "), (_vm.progress == 100) ? _c('div', {
    staticClass: "progress-complete"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.progress_complete')))]) : _vm._e(), _vm._v(" "), (_vm.item.sync_status) ? _c('lead-update-crm-status', {
    class: {
      'inactive-status': _vm.item.sync_status == 'sync_ready' && _vm.$store.getters.getOrganizationConfig('crm_presence') == false
    },
    attrs: {
      "structure": _vm.structure,
      "lead": _vm.item
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lead-update-monitor--section no-padding"
  }, [_c('div', {
    class: [{
      'bordered': _vm.item.businesscard_image_url
    }, 'lead-update-monitor--business-card']
  }, [_c('lead-update-business-card', {
    attrs: {
      "lead": _vm.item
    },
    on: {
      "openBusinessCard": _vm.openBusinessCard
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lead-update-monitor--section"
  }, [_c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    attrs: {
      "type": "radio",
      "collection": _vm.classificationCollection,
      "value": _vm.item.classification,
      "model": _vm.item.classification,
      "label": _vm.$t('models.project_lead.classification'),
      "params": {
        'no_i18n': true
      },
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputClassification
    }
  })], 1), _vm._v(" "), (_vm.allowedLeadReview()) ? _c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    attrs: {
      "type": "radio",
      "collection": _vm.statusCollection,
      "value": _vm.item.status,
      "model": _vm.item.status,
      "label": _vm.$t('models.project_lead.status'),
      "params": {
        'no_i18n': true
      },
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "capturer"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.capturer')))]), _vm._v(" "), _c('user-image', {
    attrs: {
      "firstname": _vm.item.user_firstname,
      "lastname": _vm.item.user_lastname,
      "email": _vm.item.user_email,
      "theme": "sensual-lighter"
    }
  }), _vm._v(" "), (_vm.userData()) ? _c('div', {
    staticClass: "capturer-name"
  }, [_c('p', {}, [_vm._v(_vm._s(_vm.userData()))])]) : _c('div', {
    staticClass: "capturer-name"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.capturer_unknown')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "crm-switch"
  }, [(_vm.showCrmSyncSwitch()) ? _c('form-switch', {
    attrs: {
      "reverse": true,
      "name": "sync_disabled",
      "value": _vm.item.sync_disabled,
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputCrmSync
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.item.start_date) ? _c('div', [_c('p', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.start_date')) + "\n        " + _vm._s(_vm.date(_vm.item.start_date)) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3e2cf0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdateMonitor.vue
// module id = 1957
// module chunks = 0